import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import React from "react";

import { SupText } from "../../../../components/UI/Text";

export interface ListRowProps {
  className?: string;
  label: ReactNode;
  value: ReactNode;
}

export function SupListRow({ className, label, value }: ListRowProps) {
  return (
    <div
      className={twMerge(
        "sup-list-table-row flex border-b-0.5 border-neutral-100 last-of-type:border-b-0",
        "flex-col md:flex-row md:justify-between",
        className
      )}
    >
      <SupText as="div" variant="subtitle2" className="leading-[3.25rem] text-neutral-800">
        {label}
      </SupText>
      <div className="no-scrollbar flex h-[3.25rem] items-center overflow-x-auto text-neutral-900">{value}</div>
    </div>
  );
}
